import * as React from 'react';
import styles from './FloorInputsExpanded.css';
import { EAreaPartsField } from '../../../../../../../../enums';
import { AreaPartInput } from '../../../../../../../AreaPartInput/AreaPartInput';
import { Field } from '../../../../Field';
import cn from 'classnames';
import { MAX_FLOOR } from '../constants';
import { IFloorInputsExpandedProps } from './types';

export const FloorInputsExpanded: React.FC<IFloorInputsExpandedProps> = props => {
  const { floorFrom, floorTo, onChange, id, invalidFields, onValidate, isMobile } = props;

  return (
    <div className={cn(styles['floor-inputs-container'], isMobile && styles['mobile'])}>
      <div className={styles['input-container']}>
        <div className={styles['prefix']}>c</div>
        <Field invalidFields={invalidFields} name={EAreaPartsField.FloorFrom} onValidate={onValidate}>
          <AreaPartInput
            value={floorFrom}
            id={id}
            onChange={onChange}
            name={EAreaPartsField.FloorFrom}
            maxWidth={48}
            maxValue={floorTo ?? MAX_FLOOR}
          />
        </Field>
      </div>
      <div className={styles['input-container']}>
        <div className={styles['prefix']}>по</div>
        <Field invalidFields={invalidFields} name={EAreaPartsField.FloorTo} onValidate={onValidate}>
          <AreaPartInput
            value={floorTo}
            id={id}
            onChange={onChange}
            name={EAreaPartsField.FloorTo}
            maxWidth={48}
            minValue={floorFrom}
            maxValue={MAX_FLOOR}
          />
        </Field>
      </div>
    </div>
  );
};
